import { constants } from '..';

const setBannersLoadingAction = flag => ({
  type: constants.banners.SET_BANNERS_LOADING,
  flag,
});

const setBannerImageUploadingAction = flag => ({
  type: constants.banners.SET_BANNER_IMAGE_UPLOADING,
  flag,
});

const setBannerImageAction = image => ({
  type: constants.banners.SET_BANNER_IMAGE,
  image,
});

const getBannersAction = filter => ({
  type: constants.banners.GET_BANNERS,
  filter,
});

const setBannersAction = (banners, count) => ({
  type: constants.banners.SET_BANNERS,
  banners,
  count,
});

const clearBannersAction = () => ({
  type: constants.banners.CLEAR_BANNERS,
});

const addBannerAction = (body, history) => ({
  type: constants.banners.ADD_BANNER,
  body,
  history,
});

const getBannerAction = id => ({
  type: constants.banners.GET_BANNER,
  id,
});

const setBannerAction = banner => ({
  type: constants.banners.SET_BANNER,
  banner,
});

const editBannerAction = (id, body, history) => ({
  type: constants.banners.EDIT_BANNER,
  id,
  body,
  history,
});

const exportBannersAction = filename => ({
  type: constants.banners.EXPORT_BANNERS,
  filename,
});

const uploadBannerImageAction = file => ({
  type: constants.banners.UPLOAD_IMAGE,
  file,
});

const updateBannerPriorityAction = (id, direction, filter) => ({
  type: constants.banners.UPDATE_PRIORITY,
  id,
  direction,
  filter,
});

export const bannersActions = {
  setBannersLoadingAction,
  setBannerImageUploadingAction,
  setBannerImageAction,
  getBannersAction,
  setBannersAction,
  clearBannersAction,
  addBannerAction,
  getBannerAction,
  setBannerAction,
  editBannerAction,
  exportBannersAction,
  uploadBannerImageAction,
  updateBannerPriorityAction,
};
